module.exports = __webpack_public_path__ + "static/media/faq-exemplo.46d97b20.png";